import styled from 'styled-components';

export const DueDate = styled.div`
  padding: 18px 0px;
  min-width: 450px;

  & h3 {
    color: rgb(0 0 0 / 49%);
    padding-bottom: 18px;
    font-size: 19px;

    @media (max-width: 720px) {
      padding-top: 12px;
    }
  }

  & p {
    color: #000000ab;
    font-weight: 700;
    font-size: 36px;
    padding-bottom: 34px;
  }

  & div {
    padding: 10px 10px;
    border-radius: 10px;

    width: 100%;
    max-width: 400px;
    background-color: #fff;
    margin-bottom: 37px;

    & p {
      font-size: 15px;
      font-weight: 600;
      color: rgb(0 0 0 / 53%);
      padding: 4px 10px;
    }
  }

  & span {
    font-size: 17px;
    font-weight: bold;
    color: #ef4e5e;
    text-transform: uppercase;
    padding-top: 10px;
    cursor: pointer;
  }

  @media (max-width: 720px) {
    text-align: center;
    min-width: 0px;
    padding: 0px;
    & div {
      margin: 0 0 20px;
    }
  }
`;

export const LightBulbSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 720px) {
    flex-wrap: wrap;
  }
`;

export const Recalculate = styled.span`
  display: flex;
  align-items: center;

  @media (max-width: 720px) {
    justify-content: center;
  }
`;
